import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * EmptyState — DESIGN.md
 *
 * Standardized empty / not-found / unauthenticated state.
 *
 *   <EmptyState
 *     icon={<ShoppingCart />}
 *     title="장바구니가 비어있습니다"
 *     description="상품을 담아보세요!"
 *     action={<Button variant="primary">쇼핑하러 가기</Button>}
 *   />
 */
interface EmptyStateProps {
  icon?: React.ReactNode
  title: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-20 text-center',
        className,
      )}
    >
      {icon && (
        <div className="mb-4 text-text-subtle dark:text-gray-600 [&_svg]:h-16 [&_svg]:w-16">
          {icon}
        </div>
      )}
      <h2 className="mb-2 text-lg font-bold text-text dark:text-gray-100">
        {title}
      </h2>
      {description && (
        <p className="mb-6 text-sm text-text-muted">{description}</p>
      )}
      {action}
    </div>
  )
}
